/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Invitation_ExpiredInputs */

const fr_api_invitation_expired = /** @type {(inputs: Api_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation expirée. Demandez-en une nouvelle à un administrateur.`)
};

const en_api_invitation_expired = /** @type {(inputs: Api_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation expired. Ask an administrator for a new one.`)
};

/**
* | output |
* | --- |
* | "Invitation expired. Ask an administrator for a new one." |
*
* @param {Api_Invitation_ExpiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_invitation_expired = /** @type {((inputs?: Api_Invitation_ExpiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Invitation_ExpiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_invitation_expired(inputs)
	return fr_api_invitation_expired(inputs)
});